/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import css from './PriceCardTabs.scss';
import PriceCardTab from '../PriceCardTab/PriceCardTab';
import { getFormattedAmount } from 'Helpers/numbers';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormattedMessage as Translation, injectIntl } from 'react-intl';
import { threadMeetingSelector } from 'Selectors/chat';
import withTrack from 'HOCs/withTrack/withTrack';
import { ADPV_EVENTS } from 'Constants/tracking';
import { getItemTrackingInfo } from 'Helpers/item';
import { TRANSLATION_PROPS, PRICE_CARD_TABS } from 'Constants/priceCardTabs';
import {
    updateEmiSelectedAds,
    isAdEmiSelected
} from 'Helpers/priceCardTabs';

const PriceCardTabs = props => {
    const {
        track,
        item,
        user,
        displayPrice,
        minEmi,
        minHitchAmount,
        currencySymbol,
        currentLocale,
        onConsumerFinancingLinkClick,
        enableEmiFeature,
        threadMeeting
    } = props;
    const { FULL_PRICE, EMI } = PRICE_CARD_TABS;
    const [activeTab, setActiveTab] = useState(isAdEmiSelected(item?.id) ? EMI : FULL_PRICE);
    const formattedMinEmi = minEmi?.emi ? getFormattedAmount(minEmi?.emi, currencySymbol, currentLocale) : '';
    const formattedHitchAmountEmi = getFormattedAmount(minHitchAmount, currencySymbol, currentLocale);
    const isEmiTab = activeTab === EMI;
    const isFullPriceTab = activeTab === FULL_PRICE;
    const isMarkedInterest = !!threadMeeting?.leadInfo;

    const handleClickTab = ({ id }) => {
        const fieldName = id === EMI ? EMI : FULL_PRICE;
        let trackingAttributes = { variants_shown: FULL_PRICE };

        if (id === EMI) {
            trackingAttributes = {
                item_down_payment: minHitchAmount || null,
                item_emi_amount: minEmi?.emi || null,
                item_loan_duration: minEmi?.repaymentPeriodCount || null,
                variants_shown: EMI
            };
        }
        setActiveTab(id);
        updateEmiSelectedAds(item?.id, minEmi, minHitchAmount);
        track(ADPV_EVENTS.FINANCE_OPTION_SELECT, {
            item_id: item?.id,
            seller_id: user?.id,
            field_name: fieldName,
            chosen_option: fieldName,
            variants_shown: fieldName,
            ...trackingAttributes,
            ...getItemTrackingInfo(item, user)
        });
    };

    const renderFullPriceTab = () => (
        <PriceCardTab
            id={ FULL_PRICE }
            isActive={ isFullPriceTab }
            handleClickTab={ handleClickTab }
            enableEmiFeature={ enableEmiFeature }
            isMarkedInterest={ isMarkedInterest }
        >
            <div className={ css.itemPriceLabel }>
                <Translation { ...TRANSLATION_PROPS.priceCardTabFullPriceTxt } />
            </div>
            <div
                className={ classnames(css.itemPrice, {
                    [css.fullPriceTabActive]:
                        isFullPriceTab || !enableEmiFeature || isMarkedInterest
                }) }
                data-aut-id="carPrice"
            >
                {displayPrice}
            </div>
        </PriceCardTab>
    );

    const renderEmiTab = () => (
        <PriceCardTab
            id={ EMI }
            isActive={ isEmiTab }
            handleClickTab={ handleClickTab }
            enableEmiFeature={ enableEmiFeature }
            isMarkedInterest={ isMarkedInterest }
        >
            <div data-aut-id="emiLabel" className={ css.emiLabel }>
                <Translation { ...TRANSLATION_PROPS.priceCardTabEmiTxt } />
            </div>
            <div className={ css.emiPrice }>
                <span
                    data-aut-id="emiPrice"
                    className={ classnames(css.itemPrice, {
                        [css.emiTabActive]: isEmiTab || isMarkedInterest
                    }) }
                >
                    {formattedMinEmi}
                </span>
                &nbsp;
                <span className={ css.emiMonths }>
                    x {minEmi?.repaymentPeriodCount}&nbsp;
                    <Translation { ...TRANSLATION_PROPS.priceCardTabMonths } />
                </span>
            </div>
            {!!minHitchAmount && (
                <div data-aut-id="downPayment" className={ css.downPaymentLabel }>
                    <Translation { ...TRANSLATION_PROPS.priceCardTabDownPayment } />
                    &nbsp;
                    <span className={ css.downPaymentAmount }>{formattedHitchAmountEmi}</span>
                </div>
            )}
            {(isEmiTab || isMarkedInterest) && (
                <div
                    data-aut-id="emiCalculator"
                    className={ css.cfLink }
                    onClick={ onConsumerFinancingLinkClick }
                    role="button"
                >
                    <Translation { ...TRANSLATION_PROPS.emiCalculator } />
                </div>
            )}
        </PriceCardTab>
    );

    return (
        <div data-aut-id="PriceCardTabs" className={ css.tabsContainer }>
            {renderFullPriceTab()}
            {enableEmiFeature && renderEmiTab()}
        </div>
    );
};

PriceCardTabs.propTypes = {
    minEmi: PropTypes.shape({
        emi: PropTypes.number,
        repaymentPeriodCount: PropTypes.number
    }),
    minHitchAmount: PropTypes.number,
    currencySymbol: PropTypes.shape({
        pre: PropTypes.string,
        post: PropTypes.string
    }),
    currentLocale: PropTypes.string,
    displayPrice: PropTypes.string,
    onConsumerFinancingLinkClick: PropTypes.func,
    enableEmiFeature: PropTypes.bool,
    threadMeeting: PropTypes.object,
    track: PropTypes.func,
    item: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
};

PriceCardTabs.defaultProps = {
    onConsumerFinancingLinkClick: () => {},
    threadMeeting: {},
    item: {},
    user: {}
};

const mapStateToProps = (state, ownProps) => {
    const { user, item } = ownProps;

    return {
        threadMeeting: threadMeetingSelector(state, { userId: user?.id, itemId: item?.id })
    };
};

export default compose(
    injectIntl,
    withTrack,
    connect(mapStateToProps, null)
)(PriceCardTabs);
